module.exports = __webpack_public_path__ + "static/img/cup.e1fc871a.png";